import { render } from "./Precipitation.vue?vue&type=template&id=40bf8aca&scoped=true"
import script from "./Precipitation.vue?vue&type=script&lang=js"
export * from "./Precipitation.vue?vue&type=script&lang=js"

import "./Precipitation.vue?vue&type=style&index=0&id=40bf8aca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40bf8aca"]])

export default __exports__